<template>
  <div>
    <img @error="bindLoadError" class="image" :src="imageUrl" alt="" />
  </div>
</template>
<script>
export default {
  data() {
    return {
      imageUrl:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a0cabba57f5757491f65d43b08895550.png'
    }
  },
  methods: {
    bindLoadError() {
      this.$toast('图片加载失败,请重试')
    }
  }
}
</script>
<style lang="scss" scoped>
.image {
  width: 100%;
}
</style>
